/**
 * CAS_TIP (SABIT ST_TUR=127 ST_KODINT) → ilişkili SABIT ST_TUR grupları.
 * SABITGRUP 127 altındaki satış tipleri ile birebir.
 */
export const SATIS_TIPI_ST_TUR = 127;

export const SATIS_TIPI_GROUPS = Object.freeze({
  1: { satisTuru: 19, paket: 21, islem: 126 },
  2: { satisTuru: 135, paket: 131, islem: 123 },
  3: { satisTuru: 136, paket: 132, islem: 124 },
  4: { satisTuru: 137, paket: 133, islem: 125 },
  5: { satisTuru: 140, paket: 141, islem: 142 },
  7: { satisTuru: 143, paket: 144, islem: 145 },
});

/** globals / legacy kod için takma ad → CAS_TIP */
export const SATIS_TIPI_ALIASES = Object.freeze({
  ekim: 1,
  ekimekpaket: 2,
  medikalestetik: 3,
  fiziktedavi: 4,
  ekimurun: 5,
  medikalesurun: 7,
});

export const KNOWN_CAS_TIPS = Object.freeze(Object.keys(SATIS_TIPI_GROUPS).map(Number));

export const ALL_ISLEM_ST_TUR = Object.freeze([...new Set(Object.values(SATIS_TIPI_GROUPS).map((g) => g.islem))]);
export const ALL_SATIS_TURU_ST_TUR = Object.freeze([...new Set(Object.values(SATIS_TIPI_GROUPS).map((g) => g.satisTuru))]);
export const ALL_PAKET_ST_TUR = Object.freeze([...new Set(Object.values(SATIS_TIPI_GROUPS).map((g) => g.paket))]);

export function getSatisTipiByCasTip(casTip) {
  const t = Number(casTip);
  if (!Number.isFinite(t)) return null;
  return SATIS_TIPI_GROUPS[t] || null;
}

export function casTipFromAlias(aliasOrCasTip) {
  if (aliasOrCasTip == null || aliasOrCasTip === '') return null;
  const n = Number(aliasOrCasTip);
  if (Number.isFinite(n) && SATIS_TIPI_GROUPS[n]) return n;
  const key = String(aliasOrCasTip);
  return SATIS_TIPI_ALIASES[key] ?? null;
}

export function getIslemStTur(casTip) {
  return getSatisTipiByCasTip(casTip)?.islem ?? null;
}

export function getSatisTuruStTur(casTip) {
  return getSatisTipiByCasTip(casTip)?.satisTuru ?? null;
}

export function getPaketStTur(casTip) {
  return getSatisTipiByCasTip(casTip)?.paket ?? null;
}

export function isKnownCasTip(casTip) {
  return getSatisTipiByCasTip(casTip) != null;
}

export function isEkimCasTip(casTip) {
  return Number(casTip) === SATIS_TIPI_ALIASES.ekim;
}

/** Takma addan ST_TUR: kind = 'islem' | 'satisTuru' | 'paket' */
export function getStTurByAlias(alias, kind = 'islem') {
  const casTip = casTipFromAlias(alias);
  if (casTip == null) return null;
  return getSatisTipiByCasTip(casTip)?.[kind] ?? null;
}

/** globals.js için: her takma ad → ilgili ST_TUR */
export function buildAliasStTurMap(kind) {
  const out = {};
  for (const [alias, casTip] of Object.entries(SATIS_TIPI_ALIASES)) {
    const g = SATIS_TIPI_GROUPS[casTip];
    if (g) out[alias] = g[kind];
  }
  return out;
}

export function lookupSabitAdByCasTip(sabitLkp, casTip, ref, field = 'satisTuru') {
  const stTur = getSatisTipiByCasTip(casTip)?.[field];
  const r = Number(ref);
  if (!stTur || !Number.isFinite(r) || r <= 0) return '';
  const list = Array.isArray(sabitLkp) ? sabitLkp : [];
  const row = list.find((x) => Number(x.ST_TUR) === stTur && Number(x.ST_REF) === r);
  return row?.ST_AD ?? '';
}
